<section class="app-download-dialog">
  <div class="app-download-grid" [class.app-download-grid--single]="visibleStores.length === 1">
    @for (store of visibleStores; track store) {
      <article class="app-download-item">
        <img
          [src]="getStoreConfig(store).qrImageUrl"
          class="app-download-qr"
          [alt]="'Código QR de descarga en ' + getStoreConfig(store).buttonLabel"
        />
        <p class="app-download-hint">
          Escanea el código QR con tu móvil para descargar en
          {{ getStoreConfig(store).buttonLabel }}.
        </p>
        <p-button
          [label]="'Abrir en ' + getStoreConfig(store).buttonLabel"
          icon="pi pi-external-link"
          [outlined]="true"
          class="w-100"
          [style]="{ width: '100%' }"
          (onClick)="openStoreInBrowser(store)"
        />
      </article>
    }
  </div>
</section>
